import * as PropTypes from 'prop-types';

export const PANES = {TEXT: 'TEXT', HIGHLIGHT: 'HIGHLIGHT'};
export const COLORS = {
  PALETTE: [
    [
      '#D10E0E',
      '#E14516',
      '#EB820F',
      '#F3C901',
      '#84C620',
      '#0DAF49',
      '#078BA9',
      '#458ADD',
      '#5548CE',
      '#6B1270',
    ],
    [
      '#DE5555',
      '#EA7C5B',
      '#ED9A49',
      '#F6D94D',
      '#A6D461',
      '#4FCB7D',
      '#33A3BD',
      '#6EA0DB',
      '#6D62D4',
      '#97599A',
    ],
    [
      '#F19797',
      '#F0A28A',
      '#FDC68A',
      '#FBE98B',
      '#C0E38B',
      '#7CE0A1',
      '#72C0D3',
      '#94B5DD',
      '#9D96E3',
      '#BC8DBF',
    ],
    [
      '#F2BBBB',
      '#F6C7B9',
      '#F9D9B7',
      '#FAEFB4',
      '#D5F0AD',
      '#ABEFC4',
      '#9FDDEE',
      '#BACDE3',
      '#C6C2F2',
      '#D2B7D4',
    ],
    [
      '#F9DCDC',
      '#F9DAD0',
      '#FEECD9',
      '#FCF5D1',
      '#E8F9CF',
      '#D4F6E1',
      '#C2EDF8',
      '#D9E3EF',
      '#DDDBF0',
      '#E1D0E2',
    ],
  ],
  GRAYS: ['#000000', '#404040', '#7F7F7F', '#999999', '#B2B2B2', '#CCCCCC', '#D9D9D9', '#E5E5E5'],
  WHITE: '#FFFFFF',
  NO_STYLE: 'NO_STYLE',
};

export interface ColorValueLink {
  value?: string | boolean | null;
  requestChange: (colorValue: string) => void;
}
export const COLOR_VALUE_LINK = PropTypes.shape({
  value: PropTypes.string,
  requestChange: PropTypes.func.isRequired,
});
